import { useState } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { useTranslation } from "react-i18next"

interface CollapsibleSidebarProps {
  children: React.ReactNode
  defaultOpen?: boolean
}

export function CollapsibleSidebar({ children, defaultOpen = false }: CollapsibleSidebarProps) {
  const [open, setOpen] = useState(defaultOpen)
  const { t } = useTranslation("nav")

  return (
    <>
      {/* Toggle Button - fixed am rechten Viewport-Rand */}
      <button
        onClick={() => setOpen(!open)}
        className={`fixed top-20 z-50 flex items-center justify-center w-6 h-12 rounded-l-lg bg-zinc-800/90 border border-white/10 border-r-0 shadow-lg transition-all duration-300 ${
          open ? "right-[18rem]" : "right-0"
        }`}
        title={open ? t("sidebar.hide") : t("sidebar.show")}
      >
        {open ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
      </button>

      {/* Collapsible Sidebar - Teil des Layouts, NICHT fixed! */}
      <aside
        className={`flex-shrink-0 border-l border-white/[6%] bg-white/[2%] transition-all duration-300 ${
          open ? "w-72" : "w-0 overflow-hidden"
        }`}
      >
        {/* Content bleibt gemounted */}
        <div className={`h-full ${open ? "visible" : "invisible"}`}>
          {children}
        </div>
      </aside>
    </>
  )
}
